export default __webpack_public_path__ + "static/media/dbGif.65e83017.gif";